import React from 'react';

const Header = () => {
  return (
    <div className="header">
        <h1 id="site-title" className="title"><span style={{fontSize:'80px', letterSpacing: '-0.05em'}}>crds</span><span>.app</span></h1>
    </div>
  );
};

export default Header;
